import { type Common } from '../common.js';
import { type MessageRequest } from '../models/previsit/messageRequest.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(urlIdentifier: string): Promise<MessageRequest> {
    const url = this.common.constructPath(`/patient-previsit/message-requests`);
    return await this.common.postJSON(url, { urlIdentifier });
  }

  async update(
    requestId: string,
    phoneNumber: string
  ): Promise<{ success: boolean; reason?: string }> {
    const url = this.common.constructPath(`/patient-previsit/message-requests/${requestId}`);
    return await this.common.patchJSON(url, { phoneNumber });
  }
}
